// import React from 'react';
// import './runningBanners.css'

// const RunningBanner = ({ offers }) => {
//   return (
//     <div className="running-banner">
//       <div className="running-banner-content">
//         {offers.map((offer, index) => (
//           <span key={index} className="running-banner-item">
//             {offer}
//           </span>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default RunningBanner;
import React from 'react';
import './runningBanners.css';

const RunningBanner = ({ offers }) => {
  const coloredOffers = offers.map((offer, index) => ({
    text: offer,
    colorClass: `color-${index % 5}` // cycle through 5 color classes
  }));

  return (
    <div className="running-banner">
      <div className="running-banner-content">
        {[...coloredOffers, ...coloredOffers].map((offer, index) => (
          <span key={index} className={`running-banner-item ${offer.colorClass}`}>
            {offer.text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default RunningBanner;
